// workflow should show the nodes in order
// each node name should display the proper enrollment

import { Workflow } from "models/workflows/Workflow";
import { useEffect, useState } from "react";
import { ApiService } from "services/ApiService";
import NodeComponent from "./NodeComponent";
import { Node } from "models/nodes/Node";
import { utilities } from "utils/utilities";
import App from "App";
import { useNavigate, useParams } from "react-router-dom";

// and the submissions for it such as the form enrollment
interface WorkflowViewerProps {
  workflowId: string;
  onEditClick: (workflow: Workflow) => void;
  //workflow: Workflow;
}

// View used by the team.
export const WorkflowViewer: React.FC<WorkflowViewerProps> = ({ workflowId, onEditClick }) => {

  const { artistId } = useParams<{ artistId: string }>();
  const [workflow, setWorkflow] = useState<Workflow | undefined>();
  const navigate = useNavigate();

  useEffect(() => {
    const loadWorkflow = async () => {
      try {
        const data = (await ApiService.getWorkflow(workflowId)).data;
        console.log(data);
        if (data) {
          setWorkflow(data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    loadWorkflow();
  }, [workflowId]);

  return (
    <div className="p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
      <div className="mb-4">
        <h2 className="text-2xl font-semibold">{workflow?.name ?? workflow?.id}</h2>
        <h3 className="text-md text-gray-600 mt-1">
          Status:{" "}
          <span className={workflow?.isActive ? "text-green-600 font-medium" : "text-red-500 font-medium"}>
            {workflow?.isActive ? "Live" : "Disabled"}
          </span>
        </h3>
        <h4 className="text-md text-gray-600 mt-1">
          Description: <span className="text-gray-800 font-medium">{workflow?.description ?? "N/A"}</span>
        </h4>
        <h4 className="text-md text-gray-600 mt-1">
          {workflow ? (
            <>
              {/* optional: in-app navigation if link is internal */}
              <button
                onClick={() => {
                  const url = workflow.getWorkflowLink(artistId ?? "");
                  if (url.startsWith("http")) {
                    window.open(url, "_blank");
                  } else {
                    navigate(url);
                  }
                }}
                className="ml-3 text-sm px-2 py-1 bg-gray-100 rounded"
              >
                Open
              </button>
            </>
          ) : null}
        </h4>    
      </div>

      <button
        onClick={() => workflow && onEditClick(workflow)}
        className="mb-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
      >
        Edit
      </button>

      <div className="grid gap-4 grid-cols-[repeat(auto-fill,minmax(150px,1fr))]">
        {workflow &&
          workflow.nodes.map((node) => (
            <div key={node.id}>
              <NodeComponent
                node={node}
                readonly={true}
                onDelete={() => console.log()}
                onUpdate={() => console.log()}
              />
            </div>
          ))}
      </div>
    </div>
  );
}